import React from 'react';
import jquery from 'jquery';
import moment from 'moment';
import { Input, Icon, Popover, Modal, DatePicker, InputNumber, Select, Checkbox, Radio, message } from 'antd';
import './style/TableCell.less';
import API_URL from '../../../common/url';
import PatientStatus from '../../execute/PatientStatus';
import ViolationTree from '../../execute/ViolationTree';
import FilterErrorTree from '../../execute/FilterErrorTree';
import PatientCodeSearchInput from '../../execute/PatientCodeSearchInput';

const TextArea = Input.TextArea;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const dateFormat = 'YYYY-MM-DD';

class EditableCell extends React.Component {
	state = {
		value: this.props.cellValue ? this.props.cellValue.value : '',
		comment: this.props.cellValue ? this.props.cellValue.comment : '',
		editable: false,
		text: this.props.cellValue || {},
		config: this.props.config
	}

	handleChange = (e) => {
		const value = e.target.value;
		if (value && value.length > 255) {
			message.warning('输入字符的长度不能超过255！');
			return;
		}
		this.setState({ value: value }, function () {
			this.props.onChange(this.state.value, "value");
		});
	}

	commentChange = (e) => {
		const value = e.target.value;
		if (value && value.length > 255) {
			message.warning('输入字符的长度不能超过255！');
			return;
		}
		this.setState({ comment: value });
		if (this.props.onChange) {
			this.props.onChange(value, "comment");
		}
	}

	clearValue = () => {
		this.setState({ value: '' });
		if (this.props.onChange) {
			this.props.onChange('', "value");
		}
	}

	handleBlur = (e) => {
		this.setState({
			editable: false,
			value: e.target.value
		}, () => {
			this.calculateHeight();
		});
	}

	handleValueBlur = (value, key) => {
		if (key == 'patientStatus') {
			if (value == '达到研究终点' || value == '其他') {
				return;
			}
		}
		this.setState({
			editable: false,
			value: value
		}, () => {
			this.calculateHeight();
		})
	}

	check = () => {
		this.setState({ editable: false }, () => {
			this.calculateHeight();
		});
		if (this.props.onChange) {
			this.props.onChange(this.state.value, "value");
		}
	}

	calculateHeight = () => {
		const table = jquery('.ant-table-scroll .ant-table-body .ant-table-fixed tbody tr');
		const table_left = jquery('.ant-table-fixed-left .ant-table-body-outer .ant-table-fixed tbody tr');
		const table_right = jquery('.ant-table-fixed-right .ant-table-body-outer .ant-table-fixed tbody tr');
		table.each((index, item) => {
			const height = jquery(item).height();
			const left = jquery(table_left).eq(index);
			const right = jquery(table_right).eq(index);
			if (height !== jquery(right).height()) {
				jquery(right).height(height);
			}
			if (height !== jquery(left).height()) {
				jquery(left).height(height);
			}
		});
	}

	edit = (e, type) => {
		this.setState({ editable: true }, () => {
			if (type == 'radio' || type == 'checkBox') {
				this.props.onChange(undefined, "reRender");
			}
			this.calculateHeight();
		});
	}

	Dbclick = () => {
		this.setState({ editable: true }, () => {
			this.calculateHeight();
		});
	}

	onTextAreaChange = (e, key, beforeValue) => {
		const value = e.target.value;
		if (value && value.length > 255) {
			message.warning('输入字符的长度不能超过255！');
			return;
		}
		if (key == 'patientStatus') {
			const newValue = beforeValue ? `${beforeValue}(${value})` : value;
			this.setState({ value: newValue });
			if (this.props.onChange) {
				this.props.onChange(newValue, "value");
			}
		} else {
			this.setState({ value: value });
			if (this.props.onChange) {
				this.props.onChange(value, "value");
			}
		}
	}

	onRadioChange = (e) => {
		const value = e.target.value;
		this.setState({ value: value });
		if (this.props.onChange) {
			this.props.onChange(value, "value");
		}
	}

	onSelectChange = (value, key, beforeValue) => {
		if (key == 'visitGroup') {
			const { currentGroup } = this.props;
			const { visitGroupingId } = currentGroup || {};
			if (value != undefined && visitGroupingId != value) {
				this.setState({ value }, () => {
					this.showGroupConfirm(value);
				});
			} else {
				this.setState({
					editable: false,
					value
				}, () => {
					this.calculateHeight();
				});
				if (this.props.onChange) {
					this.props.onChange(value, "value");
				}
			}
		} else if (key == 'patientStatus') {
			let newValue = value;
			const { preView } = this.props;
			if (value == '退出') {
				!preView && this.patientStatusRef.show();
			} else {
				if (value == undefined) {
					newValue = beforeValue ? `${beforeValue}` : '';
				} else {
					newValue = beforeValue ? `${beforeValue}(${value})` : value;
				}
				this.setState({ value: newValue });
				if (this.props.onChange) {
					this.props.onChange(newValue, "value");
				}
			}
			this.setState({ value: newValue });
			if (this.props.onChange) {
				this.props.onChange(newValue, "value");
			}
		} else {
			this.setState({ value });
			if (this.props.onChange) {
				this.props.onChange(value, "value");
			}
		}
	}

	onCheckBoxChange = array => {
		const value = array.join("//");
		this.setState({ value: value });
		if (this.props.onChange) {
			this.props.onChange(value, "value");
		}
	}

	onControlBulr = array => {
		this.setState({ editable: false }, () => {
			this.calculateHeight();
		})
	}

	onNumberChange = (number) => {
		const value = number;
		this.setState({ value: value });
		if (this.props.onChange) {
			this.props.onChange(value, "value");
		}
	}

	onDateChange = value => {
		let { config } = this.props;
		const fv = config.type.formatValue == "YYYY-MM-DD HH:MI" ? "YYYY-MM-DD HH:mm" : config.type.formatValue;
		const valueString = moment(value).format(fv);
		let valueFormat = valueString == "Invalid date" ? "" : valueString;
		this.setState({ value: valueFormat, editable: false }, () => {
			this.calculateHeight();
		});
		if (this.props.onChange) {
			this.props.onChange(valueFormat, "value");
		}
	}

	handleSelectPatient = object => {
		const value = object.patientCode;
		this.setState({ value: value });
		if (this.props.onChange) {
			this.props.onChange(value, "value");
			this.props.onPatientCodeChange(object, "value");
		}
	}

	handleInputSelect = object => {
		const { typeName } = this.props;
		if (typeName != 'Type_Filter') {
			return;
		}
		const value = object.key;
		this.setState({ value: value });
		if (this.props.onChange && !object.label) {
			this.props.onChange(value, "value");
			this.props.onPatientCodeChange(object, "value");
		}
	}

	showGroupConfirm = (value) => {
		const { visitGroup, currentGroup, isSwitchVisitGroupingSimple } = this.props;
		const { visitGroupingId } = currentGroup || {};
		const { visitGroupingName } = (visitGroup || []).find(i => i.visitGroupingId == value) || {};
        Modal.confirm({
            iconType: 'exclamation-circle',
			title: isSwitchVisitGroupingSimple
				? '是否确定切换方案'
				: <div style={{ marginLeft: 42 }}>您选择的访视分组与正在填写的方案不一致</div>,
			content: isSwitchVisitGroupingSimple
				? ''
				: `是否跳转到“${visitGroupingName}”方案继续填写？（切换方案后，原方案数据不再保留）`,
            onOk: () => {
				this.setState({
					editable: false,
					value: value
				}, () => {
					this.calculateHeight();
				});
				if (this.props.onChange) {
					this.props.onChange(value, "value");
				}
            },
            onCancel: () => {
				this.setState({
					editable: false,
					value: visitGroupingId
				}, () => {
					this.calculateHeight();
				});
				if (this.props.onChange) {
					this.props.onChange(visitGroupingId, "value");
				}
            },
        });
    }

	showViolationTree = () => {
		const { value, againstType = {} } = this.state;
		if (value && value != Number(value)) {
			this.ViolationTreeRef.show(value);
		} else {
			this.ViolationTreeRef.show(againstType.againstTypeName);
		}
	}
	
	saveViolateData = params => {
		this.setState({
			editable: false,
			againstType: {...params},
			value: params.againstTypeId || '',
		}, () => {
			this.calculateHeight();
		});
		const againstType = sessionStorage.againstType ?  JSON.parse(sessionStorage.againstType) : [];
		againstType.push({ [params.againstTypeId]: params.againstTypeName });
		sessionStorage.againstType = JSON.stringify(againstType);
		if (this.props.onChange) {
			this.props.onChange(params.againstTypeId || '', "value");
		}
	}
	
    clearAgainstType = (e) => {
		e.stopPropagation();
		this.saveViolateData({});
	}
	
	showFilterErrorTree = () => {
		const { value, filterErrorType = {} } = this.state;
		if (value && value != Number(value)) {
			this.filterErrorTreeRef.show(value);
		} else {
			this.filterErrorTreeRef.show(filterErrorType.optionValue);
		}
	}
	
	saveFilterErrorData = params => {
		this.setState({
			editable: false,
			filterErrorType: {...params},
			value: params.filterFailOptionId || '',
		}, () => {
			this.calculateHeight();
		});
		const filterErrorType = sessionStorage.filterErrorType ?  JSON.parse(sessionStorage.filterErrorType) : [];
		filterErrorType.push({ [params.filterFailOptionId]: params.optionValue });
		sessionStorage.filterErrorType = JSON.stringify(filterErrorType);
		if (this.props.onChange) {
			this.props.onChange(params.filterFailOptionId || '', "value");
		}
    }

    clearFilterErrorType = (e) => {
		e.stopPropagation();
		this.saveFilterErrorData({});
	}

	disabledDate = (current) => {
		const { config } = this.state;
		const { maxDate, typeName } = this.props;
		const { moduleDefineName } = config;
		if ((typeName === 'Type_Pre_Filter' && moduleDefineName === '预筛时间')
		|| (typeName === 'Type_Filter' && (moduleDefineName === '知情同意时间' || moduleDefineName === '筛选时间' || moduleDefineName === '随机(入组)时间'))
		|| (typeName === 'Type_Visit' && (moduleDefineName === '知情同意时间' || moduleDefineName === '筛选时间' || moduleDefineName === '完成试验时间' || moduleDefineName === '随机(入组)时间' || moduleDefineName.startsWith('实际时间')))
		|| (typeName === 'Type_Drop' && (moduleDefineName === '退出时间'))
		|| (typeName === 'Type_Violation' && (moduleDefineName === '方案违背时间'))
		|| (typeName === 'Type_SAE' && (moduleDefineName === 'SAE开始时间' || moduleDefineName === 'SAE结束时间' || moduleDefineName === 'SAE报告时间'))) {
			const value = moment(moment(maxDate).format(dateFormat)).add(1, 'd').valueOf();
			return current && current.valueOf() >= value;
		}
	}

	getRenderDom = (editable, comment) => {
		const { isRelative, parent, typeName, visitGroup = [], currentGroup, record, isUnBlind, relateCenter } = this.props;
		const { visitGroupingId, visitGroupingName } = currentGroup || {};
		const { patientUserId } = record || {};
		const { text, value, config } = this.state;
		let commentPop;
		let lockIcon = <Icon type="lock" className="un-editable" />;
		if (text.editable == 0 || this.props.isEdit == false) {
			config.isEdit = false;
		} else {
			config.isEdit = true;
		}
		if (text.color) {
			config.colorClass = text.color;
		} else {
			config.colorClass = "";
		}

		config.content = (
			<div>
				<Input type="textarea" rows={4} value={comment} disabled={!config.isEdit} onChange={this.commentChange} />
			</div>
		);
		if (config.comment.iscomment) {
			let popClass = !comment ? "pop nopop" : "pop";
			commentPop = <Popover className="popover-cell" content={config.content} title="违背备注" trigger="click"><i className={popClass}></i></Popover>;
		} else {
			commentPop = "";
		}
		const getRadioCell = () => {
			let optionValue = config.type.moduleDefineConstraintValue == undefined || config.type.moduleDefineConstraintValue == null ?
				null : config.type.moduleDefineConstraintValue.split("//");
			if (optionValue != null && config.isEdit) {
				return (
					<div className="editable-cell" onClick={e => this.edit(e, 'radio')}>
						{
							editable ?
								<div>
									<RadioGroup value={value} onBulr={this.onControlBulr} options={optionValue} onChange={this.onRadioChange} />
									<Icon type="close-circle" onClick={this.clearValue} className="clear-icon" />
								</div>
								:
								<div>
									<p className="nowrap">{value || ' '}</p>
								</div>
						}
					</div>
				);
			} else {
				return (
					<div className="editable-cell">
						{lockIcon}
						<p className="nowrap">{value || ' '}</p>
					</div>
				);
			}
		}

		const getCheckBoxCell = () => {
			let optionValue = config.type.moduleDefineConstraintValue == undefined || config.type.moduleDefineConstraintValue == null ?
				null : config.type.moduleDefineConstraintValue.split("//");
			const defaultValue = !value ? [] : value.split("//");
			if (optionValue != null && config.isEdit) {
				let checkboxShowVal = ' ';
				if (value) {
					checkboxShowVal = value.split("//").join(";");
				}
				return (
					<div className="editable-cell" onClick={e => this.edit(e, 'checkBox')}>
						{
							editable ?
								<div>
									<CheckboxGroup options={optionValue} onBulr={this.onControlBulr} onChange={this.onCheckBoxChange} value={defaultValue} />
									<Icon type="close-circle" onClick={this.clearValue} className="clear-icon" />
								</div>
								:
								<div>
									<p className="nowrap">{checkboxShowVal}</p>
								</div>
						}
					</div>
				);
			} else {
				let checkboxShowVal = ' '
				if (value) {
					checkboxShowVal = value.split("//").join(";");
				}
				return (
					<div className="editable-cell">
						{lockIcon}
						<p className="nowrap">{checkboxShowVal}</p>
					</div>
				);
			}
		}

		const getSelectCell = () => {
			let optionValue = !config.type.moduleDefineConstraintValue ?
				null : config.type.moduleDefineConstraintValue.split("//");
			if (optionValue != null && config.isEdit) {
				if (config.moduleDefineName == '访视分组') {
					const options = visitGroup.map(d => <Option key={d.visitGroupingId} title={d.visitGroupingName}>{d.visitGroupingName}</Option>);
					const newValue = (value || visitGroupingId) ? (value || visitGroupingId) + '' : undefined
					return (
						<div className="editable-cell" onClick={this.edit}>
							{
								editable
								?
									<Select style={{ width: '100%' }} value={newValue} onChange={value => this.onSelectChange(value, 'visitGroup')}>
										{options}
									</Select>
								:
									<div>
										<p className="nowrap">{ visitGroupingName || value || ' '}</p>
									</div>
							}
						</div>
					);
				} else if (config.moduleDefineName == '患者状态') {
					const options = optionValue.map(d => <Option key={d} title={d}>{d}</Option>);
					const valueList = value ? value.replace(/\)/g, '').split('(') : [];
					const firstValue = valueList[0] || '';
					const secondValue = valueList[1] || '';
					const thirdValue = valueList[2] || '';
					return (
						<div className="editable-cell" onClick={this.edit}>
							{
								editable
								?
									<div>
										<Select style={{ width: '100%' }} allowClear={true} onBlur={value => this.handleValueBlur(value, 'patientStatus')} defaultValue={firstValue} onChange={value => this.onSelectChange(value, 'patientStatus')}>
											{options}
										</Select>
										{
											firstValue == '达到研究终点' &&
											<div style={{ marginTop: 4 }}>
												<Select style={{ width: '100%' }} allowClear={true} onBlur={value => this.handleValueBlur(value, 'patientStatus')} defaultValue={secondValue} onChange={value => this.onSelectChange(value, 'patientStatus', firstValue)}>
													<Option value="死亡" title="死亡">死亡</Option>
													<Option value="疾病进展" title="疾病进展">疾病进展</Option>
													<Option value="其他" title="其他">其他</Option>
												</Select>
												{
													secondValue == '其他' &&
													<div style={{ marginTop: 4 }}>
														<TextArea style={{ width: '100%', resize: 'none' }} onBlur={this.handleBlur} value={thirdValue} rows={2} onChange={e => this.onTextAreaChange(e, 'patientStatus', `${firstValue}(${secondValue})`)} />
													</div>
												}
											</div>
										}
										{
											firstValue == '其他' &&
											<div style={{ marginTop: 4 }}>
												<TextArea style={{ width: '100%', resize: 'none' }} onBlur={this.handleBlur} value={secondValue} rows={2} onChange={e => this.onTextAreaChange(e, 'patientStatus', firstValue)} />
											</div>
										}
									</div>
								:
									<div>
										<p className="nowrap">{value || ' '}</p>
									</div>
							}
						</div>
					);
				} else {
					const options = optionValue.map(d => <Option key={d} title={d}>{d}</Option>);
					return (
						<div className="editable-cell" onClick={this.edit}>
							{
								editable
								?
									<Select style={{ width: '100%' }} allowClear={true} onBlur={this.handleValueBlur} defaultValue={value} onChange={this.onSelectChange}>
										{options}
									</Select>
								:
									<div>
										<p className="nowrap">{value || ' '}</p>
									</div>
							}
						</div>
					);
				}
			} else if (config.moduleDefineName == '筛选失败原因' && config.isEdit) {
				const { filterErrorType = {}, value } = this.state;
				let optionValue;
				if (value == Number(value)) {
					const filterErrorType = sessionStorage.filterErrorType ?  JSON.parse(sessionStorage.filterErrorType) : [];
					filterErrorType.map(item => {
						if (item[value]) {
							optionValue = item[this.props.cellValue.value];
						}
					})
				}
				return (
					<div className="editable-cell" onClick={this.edit}>
						{
							editable
							?
								<div className="against-type">
									<Input defaultValue={value && (value == Number(value) ? filterErrorType.optionValue : value)} placeholder='请选择' onClick={this.showFilterErrorTree}/>
									{
										value &&
										<Icon
											className="close"
											type="close-circle"
											onClick={this.clearFilterErrorType}
										/>
									}
								</div>
							:
								<div>
									<p className="nowrap">{ filterErrorType.optionValue || (value && (value == Number(value) ? optionValue : value)) || ' '}</p>
								</div>
						}
					</div>
				);
			} else {
				if (config.moduleDefineName == '访视分组') {
					return (
						<div className="editable-cell">
							{lockIcon}
							<p className="nowrap">{visitGroupingName}</p>
						</div>
					);
				} else {
					return (
						<div className="editable-cell">
							{lockIcon}
							<p className="nowrap">{value || ' '}</p>
						</div>
					);
				}
			}
		}

		const getInputCell = () => {
			if (config.isEdit) {
				return (
					<div className="editable-cell" onClick={this.edit}>
						{
							editable ?
								<div className="editable-cell-input-wrapper">
									<Input value={value} onChange={this.handleChange} onBlur={this.handleBlur} onPressEnter={this.check} />
								</div>
								:
								<div>
									<p className="nowrap">{value || ' '}</p>
								</div>
						}
						{commentPop}
					</div>
				);
			} else {
				return (
					<div className="editable-cell">
						<div>
							<p className="nowrap">{value || ' '}</p>
						</div>
						{lockIcon}
						{commentPop}
					</div>
				);
			}
		}

		const getTextAreaCell = () => {
			if (config.isEdit) {
				if (config.moduleDefineName == '方案违背分类' && isRelative) {
					const { againstType = {}, value } = this.state;
					let againstTypeName;
					if (value == Number(value)) {
						const againstType = sessionStorage.againstType ?  JSON.parse(sessionStorage.againstType) : [];
						againstType.map(item => {
							if (item[value]) {
								againstTypeName = item[this.props.cellValue.value];
							}
						})
					}
					return (
						<div className="editable-cell" onClick={this.edit}>
							{
								editable
								?
									<div className="against-type">
										<Input defaultValue={value && (value == Number(value) ? againstType.againstTypeName : value)} placeholder='请选择' onClick={this.showViolationTree}/>
										{
											value &&
											<Icon
												className="close"
												type="close-circle"
												onClick={this.clearAgainstType}
											/>
										}
									</div>
								:
									<div>
										<p className="nowrap">{ againstType.againstTypeName || (value && (value == Number(value) ? againstTypeName : value)) || ' '}</p>
									</div>
							}
						</div>
					);
				} else {
					return (
						<div className="editable-cell" onClick={this.edit}>
							{
								editable
								?
									<TextArea style={{ resize: 'none' }} onBlur={this.handleBlur} value={value} rows={2} onChange={this.onTextAreaChange} />
								:
									<div>
										<p className="nowrap">{value || ' '}</p>
									</div>
							}
						</div>
					);
				}
			} else {
				return (
					<div className="editable-cell">
						<p className="nowrap">{value || ' '}</p>
						{lockIcon}
					</div>
				);
			}
		}

		const getDateCell = () => {
			const { typeName } = this.props;
			let showTime = false;
			let formatValuePicker = "";
			if (config.type.formatValue) {
				if (config.type.formatValue == "YYYY-MM-DD HH:MI") {
					showTime = { format: 'HH:mm' };
					formatValuePicker = "YYYY-MM-DD HH:mm";
				} else if (config.type.formatValue == "YYYY-MM-DD HH") {
					showTime = { format: 'HH' };
					formatValuePicker = "YYYY-MM-DD HH";
				} else if (config.type.formatValue == "YYYY-MM") {
					formatValuePicker = "YYYY-MM";
				} else {
					formatValuePicker = "YYYY-MM-DD";
				}
			} else {
				formatValuePicker = "YYYY-MM-DD";
			}
			const defaultValue = !value ? null : moment(value, formatValuePicker);
			let color = "";
			if (config.colorClass) {
				color = config.colorClass;
			}
			if (config.isEdit) {
				if (showTime) {
					return (
						<div className="editable-cell" onClick={this.edit}>
							{
								editable ?
									<div className="editable-cell-date-wrapper">
										<DatePicker 
											style={{ width: '100%', color: color }} 
											format={formatValuePicker} 
											disabledDate={ typeName === 'Type_Visit' && this.disabledDate}  //bug 32685 访视记录的 年月日时分  需要选择控制 
											onChange={this.onDateChange} 
											value={defaultValue} 
											showTime={showTime} placeholder="请选择时间" />
									</div>
									:
									<div className="editable-cell-date-wrapper" onClick={this.edit}>
										<p className="nowrap" style={{ color: color }}>{value || ' '}</p>
									</div>
							}
							{commentPop}
						</div>
					);
				} else {
					return (
						<div className="editable-cell" onClick={this.edit}>
							{
								editable ?
									<div className="editable-cell-date-wrapper">
										<DatePicker 
											style={{ width: '100%', color: color }} 
											format={formatValuePicker} 
											disabledDate={this.disabledDate} 
											onChange={this.onDateChange} 
											value={defaultValue} />
									</div>
									:
									<div className="editable-cell-date-wrapper" onClick={this.edit}>
										<p className="nowrap" style={{ color: color }}>{value || ' '}</p>
									</div>
							}
							{commentPop}
						</div>

					);
				}
			} else {
				return (
					<div className="editable-cell">
						<p className="nowrap" style={{ color: color }}>{value || ''}</p>
						{lockIcon}
						{commentPop}
					</div>
				);
			}
		}

		const getNumberCell = () => {
			const { isEdit, formatValue } = config;
			if (isEdit) {
				const settings = {};
				if (formatValue) {
					settings.precision = (String(formatValue).split('.')[1] || '').length;
				}
				return (
					<div className="editable-cell" onClick={this.edit}>
						{
							editable
							?
								<InputNumber
									value={value}
									{...settings}
									style={{ width: '100%' }}
									onBlur={this.onControlBulr}
									onChange={this.onNumberChange}
								/>
							:
								<div><p className="nowrap">{value || ' '}</p></div>
						}
					</div>
				);
			} else {
				return (
					<div className="editable-cell">
						<p className="nowrap">{value || ' '}</p>
						{lockIcon}
					</div>
				);
			}
		}

		const getPatientCodeSearchInput = () => {
			if (config.isEdit) {
				const initPatientCodeValue = { key: value, label: value };
				let url = '';
				const params = {
					typeName,
					patientUserId,
				};
				if (typeName == 'Type_Visit' && config.moduleDefineName == '筛选编号') {
					url = API_URL.execute.queryPatientCodeListByVisit;
					if (parent === 'crfPeriod') {
						params.isPreview = 1;
					}
				} else if (typeName == 'Type_Filter' && config.moduleDefineName == '筛选编号') {
					url = API_URL.execute.queryPatientCodeListByFilter;
				}  else if (typeName == 'Type_SAE' && config.moduleDefineName == '筛选编号') {
					url = API_URL.execute.queryPatientCodeListBySAE;
				}
				if (typeName == 'Type_Drop') {
					params.isQuit = 1;
				}
				return (
					<div onClick={this.edit} className="editable-cell">
						{
							editable
							?
								<PatientCodeSearchInput
									url={url}
									params={params}
									defaultValue={value}
									style={{ width: '100%' }}
									handleSelectPatient={this.handleSelectPatient}
									initValue={initPatientCodeValue}
									handleInputSelect={this.handleInputSelect}
								/>
							:
								<div>
									<p className="nowrap">{ initPatientCodeValue.value || value || ' ' }</p>
								</div>
						}
					</div>
				);
			} else {
				return (
					<div className="editable-cell">
						<p className="nowrap">{value || ' '}</p>
						{lockIcon}
					</div>
				);
			}
		}

		switch (config.type.type) {
			case "TEXT":
				switch (config.type.webType) {
					case "RADIO":
						return getRadioCell();
					case "SELECT":
						return getSelectCell();
					case "CHECKBOX":
						return getCheckBoxCell();
					case "TEXTAREA":
						return getTextAreaCell();
					default:
						return getInputCell();
				}
			case "DATE":
				return getDateCell();
			case "NUMBER":
				return getNumberCell();
			case "PatientCodeSearchSelect":
				if (typeName === 'Type_Visit' && isUnBlind && !relateCenter) {
					return getInputCell();
				}
				return getPatientCodeSearchInput();
			default:
				return getInputCell();
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.cellValue == undefined && this.state.value == '' && nextState.editable == this.state.editable && this.state.comment == nextState.comment) {
			return false;
		}
		if (nextProps.cellValue && nextProps.cellValue.value) {
			if ((nextProps.cellValue.value == (this.props.cellValue && this.props.cellValue.value)) && nextState.value == this.state.value
				&& (nextProps.cellValue.comment == (this.props.cellValue && this.props.cellValue.comment)) && this.state.comment == nextState.comment
			) {
				if (nextProps.isEdit == this.props.isEdit && nextState.editable == this.state.editable) {
					return false;
				}
			}
		}
		return true;
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.cellValue && (nextProps.cellValue.value || nextProps.cellValue.value == "")) {
			this.setState({
				value: nextProps.cellValue.value
			})
		}
		this.setState({
			config: nextProps.config,
			text: nextProps.cellValue || {},
		})
	}

	render() {
		const { maxDate } = this.props;
		const { value, comment, editable } = this.state;
		return (
			<div>
				{this.getRenderDom(editable, comment)}
				<PatientStatus ref={el => this.patientStatusRef =el} value={value} maxDate={maxDate} />
				<ViolationTree ref={el => this.ViolationTreeRef = el} saveViolateData={this.saveViolateData} isEnd={true} />
				<FilterErrorTree ref={el => this.filterErrorTreeRef = el} saveFilterErrorData={this.saveFilterErrorData} isEnd={true} />
			</div>
		)
	}
}

export default EditableCell;


// WEBPACK FOOTER //
// ./src/components/common/tableCell/TableCell.js